import { pushDataLayer } from '../helpers/pushDataLayer'
type props = {
  id: string
  block?: ScrollLogicalPosition
  dataLayerEvent?: Object
}
export const scrollToElement = ({ id, block = 'start', dataLayerEvent }: props): void => {
  const el = document.getElementById(id)
  if (dataLayerEvent) pushDataLayer(dataLayerEvent)
  if (el) {
    el.scrollIntoView({ block: block, behavior: 'smooth' })
    // Find all input in element, set focus on first if any.
    const inputEl = el.getElementsByTagName('input')
    if (inputEl.length > 0) {
      inputEl[0].focus()
    }
  }
}

window.scrollToElement = scrollToElement
